module.exports = __webpack_public_path__ + "static/media/tokenpocket.c2ae6207.webp";